import { footerStyles } from './footer.css';
import { Container } from '../container/container';
import { Avocado } from '../avocado/avocado';

export const Footer = () => {
  return (
    <footer>
      <div className={footerStyles}>
        <Container>
          <Avocado />
        </Container>
      </div>
    </footer>
  );
};
